export default __webpack_public_path__ + "static/media/zilius-full.43374bf2.png";